import React from "react";

import clsx from "clsx";
import { useTranslation } from "react-i18next";

/** mui */
import { makeStyles } from "@material-ui/core/styles";

import MenuItems from "./MenuItems";

const useStyles = makeStyles((theme) => ({
    dropdown: {
        position: "absolute",
        left: "auto",
        right: -16,
        fontSize: "0.875rem",
        zIndex: 9999,
        minWidth: "10rem",
        padding: theme.spacing(1, 2),
        listStyle: "none",
        borderRadius: "0.5rem",
        backgroundColor: "#F8F9FA",
        boxShadow: `0px 4px 8px rgba(0, 0, 0, 0.2)`,
        display: "none",
    },
    dropdownShow: {
        display: "block",
    },
    dropdownSubmenu: {
        position: "absolute",
        left: "100%",
        top: -7,
    },
}));

const Dropdown = ({ submenus, dropdown, depthLevel, isLast }) => {
    const { t } = useTranslation();
    const classes = useStyles();

    depthLevel = depthLevel + 1;

    const maxNameWidth = Math.max(...submenus?.map((submenu) => t(submenu?.name)?.length));

    return (
        <ul
            className={clsx(
                classes.dropdown,
                depthLevel > 1 && classes.dropdownSubmenu,
                dropdown && classes.dropdownShow
            )}
            style={{ minWidth: maxNameWidth * 11, marginTop: depthLevel > 1 ? 8 : "unset" }}
            
        >
            {submenus.map((submenu, index) => (
                <MenuItems items={submenu} key={index} depthLevel={depthLevel} isLast={depthLevel >0 && submenus.length === index + 1} />
            ))}
        </ul>
    );
};

export default Dropdown;
